/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkDeleteTimesheetEntriesData
 */
export interface BulkDeleteTimesheetEntriesData {
    /**
     * The ids of models to delete
     * @type {Array<number>}
     * @memberof BulkDeleteTimesheetEntriesData
     */
    ids: Array<number>;
}

/**
 * Check if a given object implements the BulkDeleteTimesheetEntriesData interface.
 */
export function instanceOfBulkDeleteTimesheetEntriesData(value: object): value is BulkDeleteTimesheetEntriesData {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    return true;
}

export function BulkDeleteTimesheetEntriesDataFromJSON(json: any): BulkDeleteTimesheetEntriesData {
    return BulkDeleteTimesheetEntriesDataFromJSONTyped(json, false);
}

export function BulkDeleteTimesheetEntriesDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkDeleteTimesheetEntriesData {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
    };
}

  export function BulkDeleteTimesheetEntriesDataToJSON(json: any): BulkDeleteTimesheetEntriesData {
      return BulkDeleteTimesheetEntriesDataToJSONTyped(json, false);
  }

  export function BulkDeleteTimesheetEntriesDataToJSONTyped(value?: BulkDeleteTimesheetEntriesData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
    };
}

